import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppConfig } from "./context";
const featureFlags = {
  disableTableSort: true, // not in scope yet
};

type IProps = {
  children: any;
  baseUrl: string;
  baseAppUrl: string;
  baseDeviceUrl: string;
  baseStorageUrl: string;
  tenantId: string;
  configBrand: string;
  productCode: string;
  appRegionId: string
};

const AppConfigProvider = (props: IProps) => {
  const { i18n } = useTranslation();
  const { baseUrl, baseAppUrl, baseDeviceUrl, baseStorageUrl, tenantId, configBrand, productCode, appRegionId} = props;
  const [config, updateConfig] = useState({
    baseUrl: baseUrl,
    baseAppUrl: baseAppUrl,
    baseDeviceUrl: baseDeviceUrl,
    baseStorageUrl: baseStorageUrl,
    tenantId: tenantId,
    token: "",
    language: "",
    configBrand: configBrand,
    productCode: productCode,
    appRegionId: appRegionId
  });

  const [userProfile, updateUserProfile] = useState<any>({});
  const [userLegal, updateUserLegal] =  useState<any>({});
  const [availableFeatures, setAvailableFeatures] = useState<string[]>([]);
  const [applicationFeatures, setApplicationFeatures] = useState<any[]>([]);
  const [subscribedApps, setSubscribedApps] = useState<string[]>([]);
  const [allApps, setAllAps] = useState<any>([]);
  const [userAccessApps, setUserAccessApps] = useState<any>([]);
  const [availableApps, setAvailableApps] = useState<any>([]);
  
  useEffect(() => {
    updateConfig((prevConfig: any) => {
      return {
        ...prevConfig,
        app: "developer-portal", // 'provider-portal' | 'dev-portal'
        baseUrl: baseUrl,
        baseAppUrl: baseAppUrl,
        baseDeviceUrl: baseDeviceUrl,
        baseStorageUrl: baseStorageUrl,
        // baseUrl: 'https://ch-1064-7040:5010/api',
        tenantId: tenantId,
        configBrand: configBrand,
      };
    });
  }, [baseUrl, tenantId, baseAppUrl, baseDeviceUrl, baseStorageUrl]);

  const setConfig = (config: any) => {
    updateConfig(config);
  };

  const setUserProfile = (userProfile: any) => {
    updateUserProfile(userProfile);
  };

  const setUserLegal = (userLegal: any) => {
    updateUserLegal(userLegal)
  }

  const updateUserLocale = async (locale: string) => {
    try {
      // TODO: Call an API endpoint so the locale change is persistent
      await i18n.changeLanguage(locale);
      updateUserProfile({ ...userProfile, locale });
      setConfig((prevConfig: any) => {
        return {
          ...prevConfig,
          language: locale,
        };
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <AppConfig.Provider
      value={{
        featureFlags,
        config,
        setConfig,
        userProfile,
        setUserProfile,
        updateUserLocale,
        setUserLegal,
        userLegal,
        setAvailableFeatures,
        availableFeatures,
        setApplicationFeatures,
        applicationFeatures,
        subscribedApps, setSubscribedApps,
        allApps, setAllAps,
        userAccessApps, setUserAccessApps,
        availableApps, setAvailableApps
      }}
    >
      {props.children}
    </AppConfig.Provider>
  );
};

export default AppConfigProvider;